import React, { useRef, useState } from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import { toast, Toaster } from "react-hot-toast";
import NavBar from "../components/NavbarTwo";
import FooterFour from "../components/FooterFour";
import { Link } from "react-router-dom";

const srOnly = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  whiteSpace: "nowrap",
  border: 0,
};

const ApplyForm = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(form.current);
    const payload = Object.fromEntries(formData.entries());

    try {
      const response = await fetch("/api/apply.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Request failed");
      }

      toast.success("Application submitted successfully! We'll be in touch soon.");
      e.target.reset();
    } catch (error) {
      toast.error("Failed to submit application. Please try again or email us directly.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <SEO canonical="/apply" {...PAGES["/apply"]} />
      <NavBar />
      <div className="contact-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="contact-page-inner bg-gray">
            <div className="section-title mb-4 pb-2">
              <h1 className="title">Let's Kickstart Your Idea</h1>
              <p className="content mb-0">
                We are committed to support and encourage outstanding technology
                entrepreneurs to innovate, grow and bring game changing ideas to
                the global marketplace.
              </p>
            </div>

            <form ref={form} onSubmit={sendEmail}>
              <div className="row">
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="venture" style={srOnly}>Project or company name</label>
                    <input
                      id="venture"
                      name="venture_name"
                      type="text"
                      placeholder="Project / Name of company."
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="email" style={srOnly}>Email</label>
                    <input
                      id="email"
                      name="company_email"
                      type="email"
                      placeholder="Enter Your Email."
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="location" style={srOnly}>Location</label>
                    <input
                      id="location"
                      name="location"
                      type="text"
                      placeholder="Enter Your Location."
                      required
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="raise" style={srOnly}>Current raise</label>
                    <input
                      id="raise"
                      name="current_raise"
                      type="text"
                      placeholder="Current Raise."
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="fund" style={srOnly}>Fundraising details</label>
                    <textarea
                      id="fund"
                      name="fund_raise"
                      cols="1"
                      rows="5"
                      placeholder="Fundraising Details."
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="previous_raise" style={srOnly}>Previous fundraising details</label>
                    <textarea
                      id="previous_raise"
                      name="previous_raise"
                      cols="1"
                      rows="5"
                      placeholder="Previous Fundraising Details."
                      required
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="project" style={srOnly}>Project link or demo</label>
                    <input
                      id="project"
                      name="project_link"
                      type="text"
                      placeholder="Project Link / Demo."
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="source" style={srOnly}>How did you hear about us</label>
                    <input
                      id="source"
                      name="source_raise"
                      type="text"
                      placeholder="How did you hear about us."
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 form-check">
                  <input className="form-check-input" type="checkbox" value="" id="optin" required aria-required="true" />
                  <label className="form-check-label" htmlFor="optin" >I agree to <Link to="/terms">Terms &amp; Conditions</Link> provided by Evolvelab Solutions Inc. By providing my phone number, I agree to receive text messages from the business.</label>
                </div>
              <div className="col-md-12 text-center">
                <button
                  type="submit"
                  id="submitBtn"
                  className="btn btn-main btn-base border-radius-5 mr-20"
                  disabled={isSubmitting}
                  style={{ minWidth: '150px' }}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Application'}
                </button>
              </div>
            </form>
            <Toaster position="bottom-center" reverseOrder={false} />
          </div>
        </div>
      </div>
      <FooterFour />
    </>
  );
};

export default ApplyForm;
